<template>
  <reporting-api pageName="podStoreDetails" :countdown="true" :parameters="{location: $route.params.server}" :updateflag="updateFlag">
    <template slot-scope="data">
      <server-details :page="data.page" :location="$route.params.server" @reload-required="reloadAll"/>
    </template>
  </reporting-api>
</template>

<script>
import ReportingApi from '@/components/ReportingApi.vue'
import ServerDetails from '@/components/Pod/ServerDetails.vue'

export default {
  components: { ReportingApi, ServerDetails },
  data () {
    return {
      updateFlag: ''
    }
  },
  methods: {
    reloadAll () {
      this.updateFlag = new Date().toISOString()
    }
  }
}
</script>
